import React from 'react';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Input from '@amzn/meridian/input';
import { ICellRendererParams } from 'ag-grid-community';
import AgileUploadRow from '@components/agile/types/AgileUploadRow';
import { AssortmentEntryAction } from '@graphql/generated/graphql';
import Text from '@amzn/meridian/text';

const FacingQuantityButtonCellRenderer = (props: {
  value: number;
  setValue: (input: number) => void;
  column: { colId: string };
  node: ICellRendererParams;
}) => {
  const { value, setValue, column, node } = props;

  const data = node.data as AgileUploadRow;
  const onIncrement = () => {
    setValue(+value + 1);
  };

  const onDecrement = () => {
    const minFacingUnits = column.colId.valueOf() === 'facingUnits' ? 1 : 0;
    setValue(Math.max(minFacingUnits, +value - 1));
  };
  const onInputHandler = (input: string | number) => {
    const minFacingUnits = column.colId.valueOf() === 'facingUnits' ? 1 : 0;
    setValue(Math.max(minFacingUnits, +input));
  };
  return (
    <div>
      {(() => {
        if (data.action?.action === AssortmentEntryAction.Remove) {
          return <Text alignment="center">{value}</Text>;
        }

        return (
          <Row spacing="none" spacingInset="none" maxWidth="50">
            <Button onClick={onDecrement} type="secondary">
              -
            </Button>
            <Input width="60px" type="number" value={value} onChange={onInputHandler} role="spinbutton" />
            <Button onClick={onIncrement} type="secondary">
              +
            </Button>
          </Row>
        );
      })()}
    </div>
  );
};

export default FacingQuantityButtonCellRenderer;
